<template lang="pug">
    div
        p(v-html="pData.warranty.title" class="font-bold")
        div(v-html="pData.warranty.content")
        FileList(v-if="pData.warranty.files" :files="pData.warranty.files")
        VideoList(v-if="pData.warranty.videos" :videos="pData.warranty.videos")
</template>

<script>
import FileList from './fileList'
import VideoList from './videoList'

export default {
    name: 'Warranty',
    components: {
        FileList,
        VideoList,
    },
    computed: {
        pData() {
            return this.$store.state.product.data
        },
    },
}
</script>
